$(function () {
  if ($("#product-repair").length > 0) {
    console.log('hogehoge')
    $(".template-product").removeClass("template-product");
  }
  function modalVideo() {
    new ModalVideo('div.js-modal-btn')
  }

  function moreButton() {
    $('.more-button').on('click', function () {
      $('.more-item').fadeIn()
      $('.more-item').show()
      $(this).hide()
    })
  }

  function tarariraSoundToggle() {
    const toggle = (tag) => {
      const base = '.tararira .section-sounds .' + tag
      const on = `${base} .on`
      const off = `${base} .off`
      $(`${base} .button-wrapper .on`).on('click', function () {
        $off = $(off)
        $on = $(on)
        $iframe = $(off + 'iframe')
        $iframe.css('heigth', '20px')
        $on.removeClass('on')
        $on.addClass('off')
        $off.removeClass('off')
        $off.addClass('on')
      })
    }
    toggle('bass')
    toggle('synth')
    toggle('misc')
    toggle('guitar')

    if (screen.width > 700) {
      const tag = 'guitar'
      const base = '.tararira .section-sounds .' + tag
      const on = `${base} .on`
      const off = `${base} .off`
      $off = $(off)
      $on = $(on)
      $iframe = $(off + 'iframe')
      $iframe.css('heigth', '20px')
      $on.removeClass('on')
      $on.addClass('off')
      $off.removeClass('off')
      $off.addClass('on')
    }
  }

  function amazon_button() {
    function initialize() {
      $('.section-amazon .button-outline').addClass('off')
      $('.section-amazon .button-lower-inner').addClass('off')
      $('.section-amazon .amazon-list').addClass('off')
    }
    initialize()

    $('.section-amazon .button-outline').on('click', function () {
      if ($(this).hasClass('on')) {
        $(this).removeClass('on')
        $('.section-amazon .button-lower-inner').removeClass('on')
        $('.section-amazon .amazon-list').removeClass('on')
        $(this).addClass('off')
        $('.section-amazon .button-lower-inner').addClass('off')
        $('.section-amazon .amazon-list').addClass('off')
      } else {
        $(this).removeClass('off')
        $('.section-amazon .button-lower-inner').removeClass('off')
        $('.section-amazon .amazon-list').removeClass('off')
        $(this).addClass('on')
        $('.section-amazon .button-lower-inner').addClass('on')
        $('.section-amazon .amazon-list').addClass('on')
      }
    })
  }

  function image_slider() {
    var is_animate = false
    function initialize() {
      if ($('.section-dealers .image-container').children().length < 2) {
        var $dealers = $('.section-dealers')
        $dealers
          .find('.prev-button,.next-button,.pager-wrapper')
          .addClass('off')
        $('.section-dealers .image-container')
          .children()
          .each(function () {
            $(this).addClass('on')
          })
        return
      }
      if ($('.section-dealers .image-container').children().length < 3) {
        var array = []
        $('.section-dealers .image-container')
          .children()
          .each(function () {
            array.push($(this).clone(true))
          })
        // console.log('log')
        array.forEach(function (elem) {
          // console.log('log2')
          $('.section-dealers .image-container').append(elem)
        })
      }
      $('.section-dealers .image-container')
        .children()
        .each(function () {
          $(this).addClass('off').addClass('animate')
        })
      $('.section-dealers .image-container .image-wrapper:first-of-type')
        .addClass('on')
        .removeClass('off')
      $('.section-dealers .pager-wrapper')
        .children()
        .each(function () {
          $(this).addClass('off')
        })
      $('.section-dealers .pager-wrapper .pager:first-of-type')
        .addClass('on')
        .removeClass('off')
      remove_prev_and_next()
      add_prev()
      add_next()
    }
    initialize()

    $('.next-button button').on('click', function () {
      if (is_animate === true) {
        return
      }
      is_animate = true
      setTimeout(function () {
        is_animate = false
      }, 200)
      var $on = $(this).closest('.wrapper1').find('.image-slider .on')
      if ($on.next().length === 0) {
        $(this)
          .closest('.wrapper1')
          .find('.image-wrapper:first-of-type')
          .addClass('on')
          .removeClass('off')
      } else {
        $on.next().addClass('on').removeClass('off')
      }
      $on.removeClass('on').addClass('off')
      set_pager()
      remove_prev_and_next()
      add_prev()
      add_next()
    })

    $('.prev-button button').on('click', function () {
      if (is_animate === true) {
        return
      }
      is_animate = true
      setTimeout(function () {
        is_animate = false
      }, 200)
      var $on = $(this).closest('.wrapper1').find('.image-slider .on')
      if ($on.prev().length === 0) {
        $(this)
          .closest('.wrapper1')
          .find('.image-wrapper:last-of-type')
          .addClass('on')
          .removeClass('off')
      } else {
        $on.prev().addClass('on').removeClass('off')
      }
      $on.removeClass('on').addClass('off')
      set_pager()
      remove_prev_and_next()
      add_prev()
      add_next()
    })

    function set_pager() {
      var i = 0
      var j = 0

      $('.wrapper1 .image-container')
        .children()
        .each(function () {
          if ($(this).hasClass('on')) {
            console.log('has on')
            i = j
          }
          j = j + 1
        })
      var pager_children = $('.wrapper1 .pager-wrapper').children()
      console.log(i)
      console.log(pager_children)
      console.log(pager_children.length)
      var count = i % pager_children.length
      var k = 0
      console.log(count)
      pager_children.each(function () {
        if (k === count) {
          $(this).addClass('on').removeClass('off')
          console.log('on')
        } else {
          $(this).addClass('off').removeClass('on')
          console.log('off')
        }
        k = k + 1
      })
    }

    function remove_prev_and_next() {
      $('.section-dealers .wrapper1')
        .find('.image-container')
        .children()
        .each(function () {
          $(this).removeClass('prev').removeClass('next')
        })
    }

    function add_next() {
      var $element = $('.section-dealers .wrapper1')
      var $on = $element.find('.image-container .on')
      if ($on.next().length === 0) {
        $element.find('.image-wrapper:first-of-type').addClass('next')
      } else {
        $on.next().addClass('next')
      }
    }

    function add_prev() {
      var $element = $('.section-dealers .wrapper1')
      var $on = $element.find('.image-container .on')
      if ($on.prev().length === 0) {
        $element.find('.image-wrapper:last-of-type').addClass('prev')
      } else {
        $on.prev().addClass('prev')
      }
    }

    // $('.pager').on('click', function () {
    //   var clicked = $(this);
    //   $(this).addClass('clicked');
    //   var i = 0;
    //   var j = 0;
    //   $(this).parent().children().each(function () {
    //     if ($(this).hasClass('clicked')) {
    //       j = i;
    //       $(this).addClass('on').removeClass('off').removeClass('clicked')
    //     } else {
    //       $(this).addClass('off').removeClass('on')
    //     }
    //     i = i + 1;
    //   })
    //   i = 0;
    //   $(this).closest('.wrapper1').find('.image-container').children().each(function () {
    //     if (i === j) {
    //       $(this).addClass('on').removeClass('off');
    //     } else {
    //       $(this).addClass('off').removeClass('on');
    //     }
    //     i = i + 1;
    //   })
    //   remove_prev_and_next()
    //   add_prev()
    //   add_next()
    // })
  }

  moreButton()
  image_slider()
  amazon_button()
  modalVideo()
  tarariraSoundToggle()
  async function test() {
    const url =
      'https://cdn.shopify.com/s/files/1/1557/5869/files/product__tararira__polyphonic2.mp4'
    const response = await fetch(url, { method: 'GET', mode: 'cors' })
    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)
    const video = document.createElement('video')

    video.onload = function () {
      console.log('loaded')
      URL.revokeObjectURL(this.src)
      setVideoBgColor(this, null, $('#movie-background')[0])
    }
    video.onerror = function () {
      console.log('error')
    }
    video.onplay = function () {
      console.log('played')
      // URL.revokeObjectURL(this.src)
      setVideoBgColorDelayed(this, null, $('#movie-background')[0])
      video.onplay = null
    }

    video.src = blobUrl
    video.muted = true
    video.loop = true
    video.playsinline = true
    video.load()
    video.play()
    // video.onended = () => {
    //   console.log('ended')
    //   video.play()
    // }
  }
  // test()
  // // $('.slider').slick({
  // //   dots: true,
  // //   customPaging: function(slider, i) {
  // //     return $('<button type="button" />').html('<div class="circle-inner">' + '</div>');
  // // }

  // });
  $('.owl-carousel').owlCarousel({
    loop: true,
    items: 1,
    dots: true,
    nav: true,
    navText: [],
  })
})
var scroll = new SmoothScroll(
  '#page-product .section-introduction a[href*="#"]',
  {
    speed: 100,
    easing: 'linear',
  }
)

function isColorInRange(expectedColor, givenColor) {
  // return true
  const THRESHOLD = 40
  for (var i = 0; i < 3; i++) {
    if (
      expectedColor[i] - THRESHOLD > givenColor[i] ||
      expectedColor[i] + THRESHOLD < givenColor[i]
    ) {
      return false
    }
  }
  return true
}

function setVideoBgColor(vid, nativeColor, target) {
  console.log(vid)
  console.log(nativeColor)
  console.log(target)
  if (vid) {
    let vidBg
    if (target) {
      vidBg = target
    } else {
      vidBg = vid.parentElement
      if (!vidBg) return
      vidBg = vidBg.parentElement
    }
    if (vidBg) {
      // draw first pixel of video to a canvas
      // then get pixel color from that canvas

      var canvas = document.createElement('canvas')
      console.log(vid)
      const width = vid.videoWidth
      const height = vid.videoHeight
      canvas.width = width
      canvas.height = height
      const animation = () => {
        var ctx = canvas.getContext('2d')
        ctx.drawImage(vid, 0, 0, width, height)

        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        var p = imageData.data
        const rgba = [p[0], p[1], p[2], p[3]]

        for (let i = 0; i < p.length; i += 4) {
          const inRgba = [p[i + 0], p[i + 1], p[i + 2], p[i + 3]]
          if (isColorInRange(rgba, inRgba)) {
            p[i + 3] = 0
          }
        }
        ctx.putImageData(imageData, 0, 0)
        requestAnimationFrame(animation)
      }
      document.getElementById('canvas-video').appendChild(canvas)
      // canvas.style['backgroundColor'] = '#000'
      animation()

      // console.log('rgb(' + p[0] + ',' + p[1] + ',' + p[2] + ')')
      // if (isColorInRange(nativeColor, p)) {
      // vidBg.style.backgroundColor =
      //   'rgb(' + p[0] + ',' + p[1] + ',' + p[2] + ')'
      // }
    }
  }

}

function setVideoBgColorDelayed(vid, nativeColor, target) {
  setTimeout(() => {
    setVideoBgColor(vid, nativeColor, target)
  }, 1500)
}
